<template>

  <div class="index-main">

    <img :src="images.logo" class="index-main-logo" />

    <img :src="images.title" class="index-main-title" />

    <div class="index-main-company-list">

      <div v-for="company in companyArr" :key="company.title" class="index-main-company-item"
        @click="viewCompanyDetail(company)">

        <div class="index-company-title">
          <div>
            {{ company.title }}
          </div>
        </div>

        <img :src="images.hr" class="index-company-seperator" />

        <div class="index-company-detail">
          {{ company.desc }}
          <div class="index-company-title" style="left: 0px;font-size: 12px;padding-top: 6px;">
            查看海报
          </div>
        </div>

      </div>
    </div>

    <PosterDialog :imgUrl="company.imgUrl" v-if="showDialog" :closeDialog="closeDialog" />
  </div>
</template>

<script>

import { reactive, toRefs } from "vue";

import PosterDialog from "@/components/PosterDialog";

import constants from "@/utils/constant";

import ImageLogo from "@/assets/images/logo.png";
import ImageTitle from "@/assets/images/title.png";
import ImageHr from "@/assets/images/hr.png";
import Poster1 from "@/assets/images/poster/1.jpg";
import Poster2 from "@/assets/images/poster/2.jpg";
import Poster3 from "@/assets/images/poster/3.jpg";
import Poster4 from "@/assets/images/poster/4.jpg";
import Poster5 from "@/assets/images/poster/5.jpg";
import Poster6 from "@/assets/images/poster/6.jpg";
import Poster7 from "@/assets/images/poster/7.jpg";
import Poster8 from "@/assets/images/poster/8.jpg";
import Poster9 from "@/assets/images/poster/9.jpg";

export default {
  name: "VHome",
  components: {
    PosterDialog
  },
  mounted() {
    document.title = '2022年度创新典范企业'
  },
  setup() {

    const state = reactive({
      images: {
        logo: ImageLogo,
        title: ImageTitle,
        hr: ImageHr
      },
      companyArr: constants.companyArr,
      company: {},
      posters: {
        1: Poster1,
        2: Poster2,
        3: Poster3,
        4: Poster4,
        5: Poster5,
        6: Poster6,
        7: Poster7,
        8: Poster8,
        9: Poster9
      },
      showDialog: false
    });

    const viewCompanyDetail = company => {

      const id = state.companyArr.findIndex(el => el.title === company.title) + 1;

      state.company = {
        ...company,
        id,
        imgUrl: state.posters[id]
      };

      state.showDialog = true;
    };

    const closeDialog = () => {
      state.showDialog = false;
    };

    return {
      ...toRefs(state),
      viewCompanyDetail,
      closeDialog
    };
  }
}
</script>

<style scoped>
.index-main {
  /* background-color: #001E54; */
  background-image: url(../assets/images/bg.jpg);
  background-position: 50% 50%;
  background-size: 100% 100%;
  padding-bottom: 10rem;
  min-height: 100vh;
}

.index-main-logo {
  width: calc(872px / 2.5);
  position: relative;
  top: 2rem;
  left: calc((100% - 872px / 2.5) / 2);
}

.index-main-title {
  width: calc(879px / 2.7);
  position: relative;
  left: calc((100% - 879px / 2.7) / 2);
  top: 4rem;
}

.index-main-company-list {
  position: relative;
  top: 7rem;
  left: 3%;
  /* overflow-y: auto;
  height: 37rem; */
}

.index-main-company-item {
  width: 90%;
  margin-bottom: 2rem;
}

.index-company-title {
  background-image: linear-gradient(to right, #cadef2, #1e9ad5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.1rem;
  width: 96%;
  position: relative;
  left: calc((100% - 90%) / 2);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.index-company-seperator {
  width: 130%;
  left: -15%;
  position: relative;
  top: -0.6rem;
}

.index-company-detail {
  color: white;
  font-size: 12px;
  width: 90%;
  position: relative;
  left: calc((100% - 90%) / 2);
  line-height: 1.2rem;
  opacity: 0.9;
}
</style>